angular.module('zc.projects.heatmap')

  .config(heatmapRouterConfig);

heatmapRouterConfig.$inject = ['$stateProvider'];
function heatmapRouterConfig($stateProvider) {

  $stateProvider
    .state('admin.projects.heatmap', {
      url: '/heatmap',
      views: {
        'content@': {
          template: '<zc-heatmap-list project="$resolve.project"></zc-heatmap-list>',
          resolve: {
          }
        }
      }
    }).state('admin.projects.heatmap.show', {
      url: '/:url',
      views: {
        'content@': {
          template: '<zc-heatmap></zc-heatmap>',
          resolve: {
          }
        }
      }
    });
}




// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.heatmap/routes.js